import { useState } from "react";
import { toast } from "react-toastify";
import { exportCollars } from "@services/device/collar/export";
import { exportToCSV, formatCSVData } from "@utils/export";
import { formatDateTime, actualDateTime } from "@utils/formatters";
import { COLLARS_EXPORT_HEADS } from "@typings/entities/devices/export";

export function useExportCollars() {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async () => {
    setIsLoading(true);
    try {
      const response = await exportCollars();

      if (!response.items?.length) {
        toast.warning("Nenhum dado de rastreadores disponível para exportar");
        return;
      }

      const translatedData = response.items.map((item) => ({
        ...item,
        createdAt: formatDateTime(item.createdAt),
        updatedAt: formatDateTime(item.updatedAt),
      }));

      const formattedData = formatCSVData(translatedData, COLLARS_EXPORT_HEADS);
      exportToCSV(formattedData, `relatorio_rastreadores_${actualDateTime()}`);
      toast.success("Relatório de rastreadores exportado com sucesso!");
    } catch {
      toast.error("Erro ao exportar relatório de rastreadores");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
